import React from 'react'
import './css/AboutUs.css'
import { useNavigate } from 'react-router-dom';
export default function AboutUs() {
  const navigate = useNavigate();
  const handleContactClick = () => {
    navigate("/about-us");
  };
  return (
    <section className="about-section" >
      <div className='customcontainer'>
        <div className="about-wrapper">


          <div className="about-left" data-aos="fade-up">
            <div className="main-image">
              {/* <img src='https://veersamyaksankalpproduction.s3.ap-south-1.amazonaws.com/29341a7c-4143-4367-9658-63534440b257.jpg' alt="Children" /> */}
              <img src='/images/about_us.webp' alt="Children" />
            </div>

            {/* <div className="top-image">
               <img src='https://veersamyaksankalpproduction.s3.ap-south-1.amazonaws.com/e1f5d9a2-8c3b-4a67-b2f1-0d9e7c5a4b3f.webp' alt="Group" />
         
            </div> */}

            <div className="info-card">
              <h3>100+ Children</h3>
              <p>
                Supporting Education for <br />
                <span>Underprivileged Communities</span>
              </p>
            </div>
          </div>
          <div className="about-right" data-aos="fade-up">
            <h2>Compassion in Action</h2>
            <p>
              Veer Samyak Foundation was born in 2019 from a singular, profound conviction: that every life deserves a foundation of dignity. What began as a mission to provide a definitive home for children in transition has evolved into a boundless pursuit of human welfare. Guided by spiritual inspiration and a commitment to "Seva," we transformed a simple dream of shelter into a reality of absolute security and love.
              <br />
             We believe that the most significant impacts are often the quietest. What started as a single step has grown into a much bigger mission. Seeing the smiles of children in their new home gave us the strength to go further.....
               {/* Today, we work wherever there is a need, reaching families who often have nowhere else to turn. We believe that our work is not defined by a list of services, but by our commitment to being there whenever a hand is reached out for support.
              <br />“In the quiet act of giving, we do not just change lives; we restore the strength of the human spirit.”
              <br />
              Our work is driven by people, patrons, volunteers, and well-wishers who believe that kindness can truly change the world. It is a tapestry woven by the grace of our mentors and the silent generosity of people like you. Together, we are building a future where hope is a shared inheritance and no one has to walk their path alone. */}
            </p>

           <div className="aboutus-btn-wrapper">
             <button className="read-btn" onClick={handleContactClick}>Read More →</button>
           </div>
          </div>

        </div>
      </div>
    </section>
  )
}
